/* Gadecci sliding cart glue (Oct 14, 2026).
   Makes the product page Add to cart button (and the sticky bar button) add via ajax and slide the Dawn cart drawer open,
   makes the header cart icons open the drawer instead of going to /cart, and keeps the header badges in sync.
   Relies on Dawn's cart-drawer.js (CartDrawer.renderContents / open) and cart.js. No GemPages code. */
(function () {
  'use strict';

  function drawer() { return document.querySelector('cart-drawer'); }

  /* Dawn's cart.js re-renders an element with id cart-icon-bubble after every quantity change and throws if it is missing.
     The Gadecci header has its own badges, so we keep a hidden stand in and mirror its count into the real badges. */
  function ensureBubble() {
    var b = document.getElementById('cart-icon-bubble');
    if (!b) {
      b = document.createElement('span');
      b.id = 'cart-icon-bubble';
      b.hidden = true;
      b.setAttribute('aria-hidden', 'true');
      document.body.appendChild(b);
    }
    return b;
  }

  function countFromBubbleHTML(html) {
    var doc = new DOMParser().parseFromString(html || '', 'text/html');
    var n = doc.querySelector('.cart-count-bubble span[aria-hidden]');
    return n ? parseInt(n.textContent, 10) || 0 : (doc.querySelector('.cart-count-bubble') ? 1 : 0);
  }

  function setBadges(count) {
    document.querySelectorAll('.gd-hdr-cart').forEach(function (link) {
      var badge = link.querySelector('.gd-hdr-cart-badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'gd-hdr-cart-badge';
          badge.setAttribute('aria-hidden', 'true');
          link.appendChild(badge);
        }
        badge.textContent = count > 99 ? '99+' : String(count);
      } else if (badge) {
        badge.remove();
      }
      link.setAttribute('aria-label', 'Cart (' + count + ')');
    });
    var heading = document.querySelector('.gd-cd-count');
    if (heading) heading.textContent = count > 0 ? '(' + count + ')' : '';
  }

  function syncFromBubble() {
    var b = document.getElementById('cart-icon-bubble');
    if (b) setBadges(countFromBubbleHTML(b.innerHTML));
  }

  function openDrawer(trigger) {
    var d = drawer();
    if (!d || typeof d.open !== 'function') return false;
    d.open(trigger);
    return true;
  }

  function wireHeader() {
    document.querySelectorAll('.gd-hdr-cart').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (!drawer()) return; /* no drawer on this page, let the link go to /cart */
        e.preventDefault();
        openDrawer(link);
      });
    });
  }

  function wireProductForm() {
    var form = document.getElementById('gd-product-form');
    if (!form) return;
    var btn = form.querySelector('.gd-btn--atc');
    var idle = btn ? btn.innerHTML : '';

    form.addEventListener('submit', function (e) {
      var d = drawer();
      if (!d || !window.fetch || !window.FormData) return; /* fall back to the normal /cart/add page */
      e.preventDefault();
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding to cart'; }

      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json.status || json.errors || !json.sections) {
            var msg = json.description || json.message || json.errors || 'Could not add to cart. Please try again.';
            showError(form, typeof msg === 'string' ? msg : 'Could not add to cart. Please try again.');
            return;
          }
          clearError(form);
          ensureBubble();
          d.classList.remove('is-empty');
          d.renderContents(json);
          setBadges(countFromBubbleHTML(json.sections['cart-icon-bubble']));
          if (window.publish && window.PUB_SUB_EVENTS) {
            try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gd-product-form', productVariantId: fd.get('id'), cartData: json }); } catch (err) {}
          }
        })
        .catch(function () { showError(form, 'Could not add to cart. Please check your connection and try again.'); })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = idle; }
        });
    });
  }

  function showError(form, msg) {
    var el = form.querySelector('.gd-form-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'gd-form-error';
      el.setAttribute('role', 'alert');
      form.appendChild(el);
    }
    el.textContent = msg;
  }
  function clearError(form) {
    var el = form.querySelector('.gd-form-error');
    if (el) el.remove();
  }

  function init() {
    ensureBubble();
    wireHeader();
    wireProductForm();
    var b = document.getElementById('cart-icon-bubble');
    if (b && window.MutationObserver) new MutationObserver(syncFromBubble).observe(b, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
